<script setup>
import { toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDialogA11y } from 'dashboard/composables/useDialogA11y';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import statusImage from 'dashboard/assets/real-estate/status-change-feedback/alterar_status.png';

const props = defineProps({ show: { type: Boolean, default: false } });
const emit = defineEmits(['close']);
const { t } = useI18n();
const titleId = 'post-sale-status-change-feedback-title';
const { dialogRef } = useDialogA11y({
  isOpen: toRef(props, 'show'),
  onClose: () => emit('close'),
});
</script>

<template>
  <div>
    <div
      v-if="show"
      class="fixed inset-0 z-lais-modal grid place-items-center overflow-y-auto bg-slate-950/45 p-3 sm:p-4"
      data-testid="post-sale-status-change-feedback"
      @click.self="emit('close')"
    >
      <section
        ref="dialogRef"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        tabindex="-1"
        class="relative grid max-h-[calc(100dvh-1.5rem)] w-full max-w-[1040px] overflow-y-auto rounded-[10px] bg-white shadow-xl md:grid-cols-[482px_minmax(0,1fr)] md:gap-x-[43px]"
      >
        <button
          type="button"
          class="absolute right-2 top-2 grid size-9 place-items-center rounded-full text-lais-text-muted hover:bg-lais-primary-50 focus-visible:outline-none focus-visible:shadow-lais-focus"
          :aria-label="t('POST_SALE.STATUS_CHANGE_FEEDBACK.CLOSE')"
          data-testid="post-sale-status-change-feedback-close"
          @click="emit('close')"
        >
          <span class="i-lucide-x size-4" aria-hidden="true" />
        </button>
        <img
          data-testid="post-sale-status-change-feedback-image"
          :src="statusImage"
          :alt="t('POST_SALE.STATUS_CHANGE_FEEDBACK.IMAGE_ALT')"
          class="h-auto w-full object-cover md:w-[482px]"
        />
        <div
          class="flex min-w-0 flex-col justify-between gap-8 px-5 py-8 sm:px-8 sm:py-10 md:pb-[57px] md:pl-0 md:pr-[59px] md:pt-[31px]"
        >
          <div class="space-y-3">
            <h2
              :id="titleId"
              class="max-w-[374px] font-redHatDisplay text-2xl font-bold leading-8 text-lais-text md:text-[32px] md:leading-9"
            >
              {{ t('POST_SALE.STATUS_CHANGE_FEEDBACK.TITLE') }}
            </h2>
            <p
              class="max-w-[442px] text-base leading-6 text-lais-text-body md:text-xl md:leading-6"
            >
              {{ t('POST_SALE.STATUS_CHANGE_FEEDBACK.DESCRIPTION') }}
            </p>
          </div>
          <LaisPrimaryButton
            class="self-end"
            icon="i-lucide-check"
            data-testid="post-sale-status-change-feedback-confirm"
            @click="emit('close')"
          >
            {{ t('POST_SALE.STATUS_CHANGE_FEEDBACK.CONFIRM') }}
          </LaisPrimaryButton>
        </div>
      </section>
    </div>
  </div>
</template>
